import { createContext } from 'react';

const EnvContext = createContext();
export default EnvContext